// extracted by mini-css-extract-plugin
export default {"user_btn":"UserPanel_user_btn__2N7iM"};